import React, { useEffect, useState, useMemo } from "react";
import { Link, Route, Switch, Redirect, useHistory, useLocation } from "react-router-dom";
import { useRouteMatch } from "react-router";
import ReactDOM from "react-dom";
import { store } from "index";

import { GetPrinterAll } from "api/rpc/2024-04/facilityAdmin/facility/printer";
import { GetCardReaders } from "api/rpc/2024-04/facilityAdmin/payment/teeonPayments/reader";

import TeeSheetEdit from "./teesheet/TeeSheetEdit";

import NewTeeSheet from "./teesheet/newTeeSheet/NewTeeSheet";

import Dashboard from "./dashboard/Dashboard";
// import TableService from "containers/facility/tableService";
import TableSelection from "containers/facility/tableSelection";

import Reports from "pages/secure/facility/reports/Reports"; //needs container
import Report from "pages/secure/facility/reports/Report";
import ScheduledReports from "./reports/ScheduledReports";
import reportRoutes from "./reports/ReportRoutes";

import Leagues from "pages/secure/facility/events/league/Leagues";
import LeagueNew from "pages/secure/facility/events/league/LeagueNew";
import LeaguePlayers from "pages/secure/facility/events/league/players/LeaguePlayers";
import League from "./events/league/League";

import Tournaments from "./events/tournament/Tournaments";
import TournamentNew from "./events/tournament/TournamentNew";
import Tournament from "./events/tournament/Tournament";
import TournamentSettings from "./events/tournament/settings/TournamentSettings";
import TournamentScoreSettings from "./events/tournament/settings/scoring/ScoreSettings";

import HospitalityEvents from "./events/hospitality/HospitalityEvents";
import HospitalityEventNew from "./events/hospitality/HospitalityEventNew";
import HospitalityEvent from "./events/hospitality/HospitalityEvent";

import Settings from "./settings/Settings";
import Reservation from "containers/facility/reservation/reservation";
import EditSegments from "containers/reservations/editSegments";

import Layout from "components/layout/index";
import Menu from "components/menu/index";
import Checkbox from "components/form/checkbox/Checkbox";
import Icon from "components/icon/Icon";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCashRegister,
  faChevronRight,
  faCircleInfo,
  faCreditCard,
  faPrint,
  faXmark,
} from "@fortawesome/pro-regular-svg-icons";
import "public/scss/admin.scss";
import classNames from "classnames";

import { IUIState } from "redux/reducers/ui";
import { IFacilityState } from "redux/reducers/facility";

import { IUIActions, showError } from "redux/actions/ui";
import { IAuthActions, loadFacilityAdminShift, userLogin } from "redux/actions/auth";
import { IFacilityActions, setRegisterSheet } from "redux/actions/facility";
import { ITerminalActions, setError } from "redux/actions/facilityAdmin/terminal";

import { SwitchUser, UserLogout } from "../../../api/rpc";
import { ExitSupportFacility } from "api/rpc/supportFacility";
import { StatusCode } from "../../../api/protocols";
import { IconName } from "@fortawesome/fontawesome-svg-core";
import {
  connectReader,
  MAX_RECONNECT_ATTEMPTS,
  reader,
  reconnectReader,
  setupStripe,
} from "helpers/StripeTerminalWrapper";
import { ITerminalState } from "redux/reducers/facilityAdmin/terminal";
import Sheet from "components/sheet/Sheet";
import FacilityTabTitle from "components/facilityTabTitle/FacilityTabTitle";
import { IAuthState } from "redux/reducers/auth";
import kitchenDisplaySystem from "containers/facility/kitchen/kitchenDisplaySystem";
import SwitchUserModal from "components/switchUserModal/SwitchUserModal";
import { isPositiveInteger } from "helpers/Helpers";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import LeftSubMenu from "../../../components/leftMenu/LeftSubMenu";

//Settings Submenu
import settingsOptions from "pages/secure/facility/settings/settingsOptions";
import settingsRoutes from "pages/secure/facility/settings/settingsRoutes";

//Orders Submenu
import orderOptions from "./order/OrderOptions";
import orderRoutes from "./order/OrderRoutes";

//Products Submenu
import productOptions from "./product/productOptions";
import productRoutes from "./product/productRoutes";

//Customers Submenu
import customerOptions from "./customer/customerOptions";
// import customerRoutes from "./customer/customerRoutes";

//Events Submenu
import eventOptions from "./events/EventOptions";
// import eventRoutes from "./events/EventRoutes";

//Website Builder Submenu
import websiteBuilderOptions from "./websiteBuilder/config/routes/WebsiteBuilderOptions";
import websiteBuilderRoutes from "./websiteBuilder/config/routes/WebsiteBuilderRoutes";

import { useTranslation } from "react-i18next";
import LeagueAnnouncements from "./events/league/announcements/LeagueAnnouncements";
import LeagueRounds from "./events/league/scoring/rounds/LeagueRounds";
import LeagueScoresheetNew from "./events/league/scoring/scoresheets/LeagueScoresheetNew";
import LeagueTeams from "./events/league/scoring/divisions/teams/LeagueTeams";
import LeagueTeamNew from "./events/league/scoring/divisions/teams/LeagueTeamsNew";
import LeaguePlayerManage from "./events/league/scoring/divisions/teams/LeagueTeamManagePlayers";
import LeagueTeamsEdit from "./events/league/scoring/divisions/teams/LeagueTeamsEdit";
import LeagueFlights from "./events/league/scoring/divisions/flights/LeagueFlights";
import LeagueFlightsNew from "./events/league/scoring/divisions/flights/LeagueFlightsNew";
import LeagueFlightPlayerManage from "./events/league/scoring/divisions/flights/LeagueFlightManagePlayers";
import LeagueFlightsEdit from "./events/league/scoring/divisions/flights/LeagueFlightEdit";
import LeagueScoresheetEdit from "containers/facility/leagues/leagueScoreSheetEdit";

import leagueOptions from "./events/league/LeagueOptions";
import LeagueRegistrationLanding from "./events/league/settings/registration/LeagueRegistrationLanding";
import SingleLeagueSettings from "./events/league/settings/LeagueSettings";
import TournamentPlayers from "./events/tournament/players/TournamentPlayers";
import TournamentScores from "./events/tournament/scoring/scoresheets/TournamentScores";
import tournamentOptions from "./events/tournament/TournamentOptions";
import LeagueScoresheet from "./events/league/scoring/scoresheets/LeagueScoresheet";
import LeagueLeaderboard from "./events/league/scoring/scoresheets/results/LeagueLeaderboard";
import { SupportTab } from "components/supportTab/SupportTab";
import StatusBannerStack from "components/statusBanner/StatusBannerStack";
import LeagueSkins from "./events/league/scoring/scoresheets/results/LeagueSkins";
import LeagueSkin from "./events/league/scoring/scoresheets/results/LeagueSkin";
import LeagueSeasonLeaderboard from "./events/league/scoring/leaderboards/SeasonLeaderboard";
import Leaderboards from "./events/league/scoring/leaderboards/Leaderboards";
import LeaderboardTotals from "./events/league/scoring/leaderboards/LeaderboardTotals";
import LeagueRingerBoard from "./events/league/settings/scoring/LeagueRingerBoard";
import { useWindowSize } from "hooks/useWindowSize/useWindowSize";
import { MOBILE_WIDTH } from "helpers/ScreenSizes";
import LeagueTvLeaderboard from "./events/league/scoring/scoresheets/results/LeagueTvLeaderboard";
import Customers from "./customer/main/Customers";
import CustomerProvider from "./customer/context/CustomerProvider";
import LeagueOrganizers from "./events/league/settings/organizers/LeagueOrganizers";
import TournamentOrganizers from "./events/tournament/settings/organizers/TournamentOrganizers";
import MembershipsSold from "./customer/main/MembershipsSold";
import PrintersModal from "elements/printer/PrintersModal";
import RegistersModal from "elements/register/RegistersModal";
import TournamentScoresheet from "./events/tournament/scoring/scoresheets/TournamentScoresheet";
import TournamentScoresheetNew from "./events/tournament/scoring/scoresheets/TournamentScoresheetNew";
import TournamentScoresheetEdit from "./events/tournament/scoring/scoresheets/TournamentScoresheetEdit";
import TournamentLeaderboard from "./events/tournament/scoring/scoresheets/results/TournamentLeaderboard";
import axios from "axios";
import LeagueStatistics from "./events/league/scoring/statistics/LeagueStatistics";
import LeagueTvViews from "./events/league/scoring/tvViews/TvViews";
import LeagueTvViewNew from "./events/league/scoring/tvViews/TvViewNew";
import LeagueTvViewEdit from "./events/league/scoring/tvViews/TvViewEdit";
import LeagueTvView from "./events/league/scoring/tvViews/TvView";
import TournamentTeams from "./events/tournament/scoring/teams/TournamentTeams";
import TournamentTeamNew from "./events/tournament/scoring/teams/TournamentTeamNew";
import TournamentTeam from "./events/tournament/scoring/teams/TournamentTeamEdit";
import TournamentFlights from "./events/tournament/scoring/flights/TournamentFlights";
import TournamentFlightEdit from "./events/tournament/scoring/flights/TournamentFlightEdit";
import TournamentFlightNew from "./events/tournament/scoring/flights/TournamentFlightNew";
import TournamentRegistrationLanding from "./events/tournament/settings/registration/TournamentRegistrationLanding";
import LeagueDivisions from "./events/league/scoring/divisions/LeagueDivisions";
import LeagueDivisionsNew from "./events/league/scoring/divisions/LeagueDivisionsNew";
import LeagueDivisionsManagePlayers from "./events/league/scoring/divisions/LeagueDivisionsManagePlayers";
import LeagueDivisionEdit from "./events/league/scoring/divisions/LeagueDivisionEdit";
import CustomerSegments from "./marketing/CustomerSegments";
import marketingOptions from "./marketing/MarketingOptions";
import accommodationOptions from "./accommodation/accommodationOptions";
import NewCustomerSegment from "./marketing/NewCustomerSegment";
import LeagueTeeTimes from "./events/league/settings/teeTimes/LeagueTeeTimes";
import LeaguePrizeAccounts from "./events/league/prizeAccounts/PrizeAccounts";
import PrizeAccount from "./settings/prizeAccounts/PrizeAccount";
import PrizeAccountView from "./settings/prizeAccounts/PrizeAccountView";
import PrizeAccountNew from "./settings/prizeAccounts/PrizeAccountNew";
import TournamentPrizeAccounts from "./events/tournament/prizeAccounts/PrizeAccounts";
import LeagueRoundOverview from "./events/league/scoring/rounds/LeagueRoundOverview";
import LeagueScoringFormatNew from "./events/league/scoring/rounds/scoringFormat/LeagueScoringFormatNew";
import ViewCustomerSegment from "./marketing/viewCustomerSegment/ViewCustomerSegment";
import EditCustomerSegment from "./marketing/editCustomerSegment/EditCustomerSegment";
import LeagueScoringFormatEdit from "./events/league/scoring/rounds/scoringFormat/LeagueScoringFormatEdit";
import LeagueFormatTemplates from "./events/league/settings/formatTemplates/FormatTemplates";
import LeagueFormatTemplateNew from "./events/league/settings/formatTemplates/FormatTemplateNew";
import LeagueFormatTemplate from "./events/league/settings/formatTemplates/FormatTemplate";
import FoodOrderChitMenu from "./foodOrder/FoodOrderChitMenu";
import RegisterContextProvider from "./register/registerNew/RegisterContextProvider";
import TableServiceContextProvider from "./tableService/newTableService/TableServiceContextProvider";
import TeeSheetDetailsContextProvider from "./teesheet/newTeeSheetDetails/TeeSheetDetailsContextProvider";
import { useAppDispatch } from "hooks/redux";
import teeOnMenuLogo from "../../../public/images/tee_on_menu_logo.png";
import { WebsiteBuilderEditorContainer } from "./websiteBuilder/editor/WebsiteBuilderEditor";
import DashboardNewContextProvider from "./dashboard/dashboardNew/DashboardNewContextProvider";
import Audience from "./marketing/emailCampaigns/Audience";
import CreateEmailCampaign from "./marketing/emailCampaigns/CreateEmailCampaign";
import EmailCampaign from "./marketing/emailCampaigns/EmailCampaign";
import ScheduleEmailCampaign from "./marketing/emailCampaigns/ScheduleEmailCampaign";
import EmailMarketing from "./marketing/EmailMarketing";

const EmailBuilder = React.lazy(() => import("./marketing/emailBuilder/EmailBuilder"));
import StarterTeeSheet from "./teesheet/newTeeSheet/starterTeeSheet/StarterTeeSheet";
import UserProfileTab from "components/userProfileTab/UserProfileTab";
import CartInventory from "./settings/teesheets/CartInventory";
import NewCartInventory from "./settings/teesheets/NewCartInventory";
import { CustomIcon } from "components/customIcon/CustomIcon";

import { AccommodationCalendar } from "./accommodation/calendar/AccommodationCalendar";
import { Reservations as AccommodationReservations } from "./accommodation/reservations/Reservations";
import { EditReservation as EditAccommodationReservation } from "./accommodation/reservations/EditReservation";
import { BuildingNew as AccommodationBuildingNew } from "./accommodation/buildings/BuildingNew";
import { BuildingEdit as AccommodationBuildingEdit } from "./accommodation/buildings/BuildingEdit";
import { UnitTypeNew as AccommodationUnitTypeNew } from "./accommodation/unitTypes/UnitTypeNew";
import { UnitTypeEdit as AccommodationUnitTypeEdit } from "./accommodation/unitTypes/UnitTypeEdit";
import { RatePlans as AccommodationRatePlans } from "./accommodation/rates/RatePlans";
import { EditRatePlan as AccommodationEditRatePlan } from "./accommodation/rates/EditRatePlan";
import { NewUnit as NewAccommodationUnit } from "./accommodation/units/NewUnit";
import { EditUnit as EditAccommodationUnit } from "./accommodation/units/EditUnit";
import { AccommodationConfiguration } from "./accommodation/configuration/AccommodationConfiguration";
import Kiosk from "./kiosk/Kiosk";
import NewsletterPosts from "./settings/newsletter/NewsLetterPosts";
import NewsletterPostNew from "./settings/newsletter/NewsLetterPostNew";
import NewsletterPostEdit from "./settings/newsletter/NewsLetterPostEdit";
import EventsCalendarPage from "./events/calendar/EventsCalendarPage";
import CreditBooks from "./customer/main/CreditBooks";
import {
  isAdminNavOptionActive,
  isMainAdminSettingsPath,
} from "./adminNavRouteMatching";
import Recipients from "./marketing/emailCampaigns/Recipients";
import EmailCampaignTopLinkPreview from "./marketing/emailCampaigns/EmailCampaignTopLinkPreview";

export interface ISubOptions {
  label: string;
  url: string;
  icon?: IconName;
  subOptions?: ISubOptions[];
}

export interface IOptions {
  label: string;
  url?: string;
  icon?: IconName;
  subOptions?: ISubOptions[];
  secondOptionHeader?: boolean;
  urlNewTab?: boolean;
}

interface IProps {
  authActions: IAuthActions;
  facilityActions: IFacilityActions;
  facilityStore: IFacilityState;
  terminalActions: ITerminalActions;
  terminalStore: ITerminalState;
  uiStore: IUIState;
  uiActions: IUIActions;
  authStore: IAuthState;
}

export interface IRegisterGroup {
  default: boolean;
  facility_id: number;
  id: number;
  registers: IRegister[];
  stripe_bbpos_wisepos_reader_settings_id: string;
  stripe_configuration_id: string;
  stripe_location_id: string;
  stripe_verifone_p400_reader_settings_id: string;
  tip_fixed_amount_high: null | number;
  tip_fixed_amount_low: null | number;
  tip_fixed_amount_mid: null | number;
  tip_percentage_high: null | number;
  tip_percentage_low: null | number;
  tip_percentage_mid: null | number;
  tip_smart_threshold: null | number;
  tipping_type: string;
  tipping_type_readable: string;
  title: string;
}

export interface IRegister {
  auto_log_out: boolean;
  default_card_reader_id: number | null;
  default_floor_plan_id: number | null;
  default_folder_id: number | null;
  facility_id: number;
  id: number;
  print_by_default: boolean;
  register_group?: IRegisterGroup;
  register_group_id: number;
  send_kitchen: boolean;
  title: string;
  active_shift: boolean;
  disabled: boolean;
}

export interface IPrinter {
  device_name: string;
  id: number;
  title: string;
}

interface IPath {
  name: string;
  title: string;
  icon: IconName | React.ReactElement;
  options?: Array<IOptions>;
  OnClickTitle?: () => void;
}

interface IRouteMatch {
  leagueId: string;
  tournamentId: string;
}

const FacilityAdmin: React.FC<IProps> = props => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { t, i18n } = useTranslation();
  const baseLeagueUrl = "/admin/league/:leagueId";
  const leagueId = parseInt(useRouteMatch<IRouteMatch>(baseLeagueUrl)?.params?.leagueId ?? "");
  const baseTournamentUrl = "/admin/tournament/:tournamentId";
  const tournamentId = parseInt(useRouteMatch<IRouteMatch>(baseTournamentUrl)?.params?.tournamentId ?? "");
  const { facilityStore, facilityActions, authActions, terminalStore, uiActions, authStore } = props;

  const permissions = props?.authStore?.user?.permissions;
  const canViewSubMenu = useMemo(
    () =>
      !isMainAdminSettingsPath(history.location.pathname) ||
      Boolean(authStore?.user?.permissions?.tee_sheet_starter) ||
      Boolean(authStore?.user?.permissions?.settings_access) ||
      Boolean(authStore?.user?.permissions?.admin_permissions_edit) ||
      Boolean(authStore?.user?.permissions?.admin_accounts_edit),
    [history.location.pathname, authStore?.user?.permissions],
  );
  // const facilityPermissions = props?.facilityStore?.facility?.permissions;

  const handleLogoClick = () => {
    history.push("/admin/dashboard");
  };

  async function handleExitSupportSession() {
    const exitRes = await ExitSupportFacility(true);

    if (exitRes.status !== StatusCode.OK || !exitRes.data?.user) {
      dispatch(
        showError(
          typeof exitRes.data === "object" && exitRes.data && "message" in exitRes.data
            ? String((exitRes.data as { message?: string }).message)
            : t("Unable to exit support session"),
        ),
      );
      return;
    }

    dispatch(userLogin(exitRes.data.user));
    history.push("/admin/dashboard");
  }

  useEffect(() => {
    const source = axios.CancelToken.source();
    void facilityActions.loadAdminFacility({ client: true }, false);
    void facilityActions.loadFacilityTeeSheetSettings();
    void facilityActions.loadProductValidation(source.token);
    void facilityActions.loadFacilityPrinterSettings();
    void facilityActions.loadFacilityKitchenCourses(null, false);
    void facilityActions.loadPaymentOptions(source.token);
    void facilityActions.loadRegisters(source.token);
    void facilityActions.loadStaffAccounts(source.token);
    void facilityActions.loadLoyaltyProgram(null, source.token);
    void facilityActions.loadLoyaltyProgramOffers(null, source.token);

    void facilityActions.loadAllFacilities(
      {
        "client-facilities": true,
      },
      true,
    );

    // default reader group?
    const registerGroup: undefined | IRegisterGroup = JSON.parse(
      localStorage.getItem("register_group"),
    ) as IRegisterGroup;

    // setDefaultRegisterGroup(registerGroup);
    void setupStripe(registerGroup?.id);

    return () => source.cancel();
  }, []);

  useEffect(() => {
    if (authStore?.user) {
      void dispatch(loadFacilityAdminShift(false));

      if (authStore.user.permissions?.kiosk_view && history.location.pathname !== "/admin/kiosk") {
        history.replace("/admin/kiosk");
      }
    }
  }, [authStore?.user, history.location.pathname]);

  useEffect(() => {
    const isStarterUser = Boolean(authStore?.user?.permissions?.tee_sheet_starter);
    if (isStarterUser || !canViewSubMenu) {
      setMobileLeftMenuVisible(false);
    }
  }, [authStore?.user?.permissions, canViewSubMenu, history.location.pathname]);

  // Reader - handle reconnection
  useEffect(() => {
    console.log("Terminal Store", terminalStore);
    if (terminalStore.readers?.length !== 0) {
      if (
        terminalStore.reconnectionAttempts < MAX_RECONNECT_ATTEMPTS &&
        !terminalStore.reader &&
        terminalStore.status !== "Reconnecting"
      ) {
        if (props.facilityStore?.facility?.terminal_integration !== "server") {
          uiActions.showError(
            t("secure.facility.admin.001") +
            String(Number(terminalStore.reconnectionAttempts + 1)) +
            "/" +
            String(MAX_RECONNECT_ATTEMPTS),
          );
        }

        console.log("Reconnection Attempt " + String(terminalStore.reconnectionAttempts), terminalStore.status);
        void attemptReconnect();
      }
    }

    // Set to not connected because we have failed the max number of attempts
    // if (terminalStore.reconnectionAttempts === MAX_RECONNECT_ATTEMPTS) {
    //   terminalActions.setStatus("Not Connected", false);
    // }
  }, [terminalStore.readers, terminalStore.reconnectionAttempts]);

  useEffect(() => {
    const switchUserAfterTransaction = localStorage.getItem("switch_user_after_transaction");
    if (switchUserAfterTransaction === "true") {
      setSwitchUserAfterTransaction(true);
    } else {
      setSwitchUserAfterTransaction(false);
    }
  }, [localStorage.getItem("switch_user_after_transaction")]);

  // async function loadReader(id?: number) {
  //   const registerGroup = JSON.parse(localStorage.getItem("register_group"));
  //   if (registerGroup == null) {
  //     uiActions.showError(t("secure.facility.admin.016"));
  //     return;
  //   }
  //   try {
  //     uiActions.enqueue();
  //     const setup = await setupStripe(registerGroup ? registerGroup.id : id);
  //     const readers = await discoverReaders(
  //       StripeTerminalSimulation,
  //       registerGroup ? registerGroup.stripe_location_id : undefined,
  //     );
  //   } catch (e) {
  //     uiActions.showError(t("secure.facility.admin.002"));
  //     uiActions.dequeue();
  //     return;
  //   }
  //   uiActions.dequeue();
  // }

  async function attemptReconnect() {
    const defaultTerminal = localStorage.getItem("defaultTerminal");
    if (defaultTerminal) {
      await reconnectReader(terminalStore.readers, t, undefined, message => {
        // Specific reconnection error
        setError("reconnection_error", false);
        uiActions.showError(message);
      });
    } else {
      uiActions.showError(t("secure.facility.admin.003"), 3000);
    }
  }

  const location = useLocation();

  const [currentRoute, setCurrentRoute] = useState(undefined);
  const [currentPath, setCurrentPath] = useState<IPath>(undefined);
  const [mobileLeftMenuVisible, setMobileLeftMenuVisible] = useState<boolean>(false);
  const windowSize = useWindowSize();

  // const onCollapse = () => {
  //   setCollapsed(!collapsed);
  // };

  // const [value, setValue] = useState<any>();

  const isTeesheetShellRoute =
    location.pathname === "/admin/teesheet" || location.pathname === "/admin/starter-teesheet";

  const adminContentCls = classNames("ui-main_content", {
    "no-scroll": isTeesheetShellRoute,
    "ui-main_content-teesheet": isTeesheetShellRoute,
  });

  async function logoutUser() {
    const logoutRes = await UserLogout(true);

    facilityActions.logoutFacility();
    authActions.userLogout();

    localStorage.setItem("switch_user_after_transaction", "false");
    if (Number(logoutRes.status) === Number(StatusCode.OK)) {
      history.push("/");
    }
  }

  const reportPath: { name: string; title: string; icon: IconName; hidden?: boolean } = {
    name: "report",
    title: t("secure.facility.admin.004"),
    icon: "file-chart-line",
    hidden: authStore?.user?.permissions?.tee_sheet_starter,
  };
  const teesheetPath: { name: string; title: string; icon: IconName; hidden?: boolean } = {
    name: "teesheet",
    title: t("secure.facility.admin.005"),
    icon: "stream",
    hidden: authStore?.user?.permissions?.tee_sheet_starter || !authStore.user?.permissions?.tee_sheet_access,
  };
  const reservationPath: { name: string; title: string; icon: IconName; hidden?: boolean } = {
    name: "reservation",
    title: t("secure.facility.admin.008"),
    icon: "calendar",
    hidden: authStore?.user?.permissions?.tee_sheet_starter,
  };
  const accommodationPath: {
    name: string;
    title: string;
    icon: IconName;
    hidden?: boolean;
    options?: Array<IOptions>;
  } = {
    name: "accommodation",
    title: t("Accommodations"),
    icon: "building",
    options: accommodationOptions(),
    hidden: authStore?.user?.permissions?.tee_sheet_starter,
  };

  const paths: {
    name: string;
    title: string;
    icon: IconName | React.ReactElement;
    hidden?: boolean;
    options?: Array<IOptions>;
    OnClickTitle?: () => void;
  }[] = [
      //<----------- Starter tee sheet ----------->
      {
        name: "starter-teesheet",
        title: t("Starter Tee Sheet"),
        icon: "stream",
        hidden: !authStore?.user?.permissions?.tee_sheet_starter,
      },
      ...(facilityStore?.facility?.module_tee_sheet ? [teesheetPath] : []),

      {
        name: "starter-teesheet-cart-inventory",
        title: t("Cart Inventory"),
        icon: (
          <CustomIcon
            size="medium"
            src="/public/images/powercart2-01.svg"
            colour={currentRoute === "starter-teesheet-cart-inventory" ? "white" : "blue-menu"}
          />
        ),
        hidden: !authStore?.user?.permissions?.tee_sheet_starter,
      },

      {
        name: "register",
        title: t("secure.facility.admin.006"),
        icon: "burger-soda",
        hidden: authStore?.user?.permissions?.tee_sheet_starter,
      },
      {
        name: "table-selection",
        title: t("secure.facility.admin.007"),
        icon: "plate-utensils",
        hidden: authStore?.user?.permissions?.tee_sheet_starter,
      },
      // { name: "reservation", title: t("secure.facility.admin.008"), icon: "calendar" },
      ...(facilityStore?.facility?.module_reservations ? [reservationPath] : []),

      {
        name: "order",
        title: t("secure.facility.admin.009"),
        icon: "box-open",
        options: orderOptions(),
        hidden: authStore?.user?.permissions?.tee_sheet_starter || !authStore?.user?.permissions?.orders_access,
      },
      {
        name: "product",
        title: t("secure.facility.admin.010"),
        icon: "tag",
        options: productOptions(),
        hidden: authStore?.user?.permissions?.tee_sheet_starter || !authStore?.user?.permissions?.products_access,
      },
      {
        name: "customers",
        title: t("secure.facility.admin.011"),
        icon: "user",
        options: customerOptions(),
        hidden: authStore?.user?.permissions?.tee_sheet_starter || !authStore?.user?.permissions?.customers_access,
      },
      {
        name: "events",
        title: t("secure.facility.admin.012"),
        icon: "trophy",
        options: eventOptions(),
        hidden: authStore?.user?.permissions?.tee_sheet_starter,
      },
      {
        name: "league",
        title: t("secure.facility.admin.039"),
        icon: "trophy",
        hidden: true,
        options: leagueOptions(t, leagueId),
        OnClickTitle: () => history.push("/admin/events"),
      },
      {
        name: "tournament",
        title: t("secure.facility.admin.040"),
        icon: "trophy",
        hidden: true,
        options: tournamentOptions(t, tournamentId),
        OnClickTitle: () => history.push("/admin/events-tournament"),
      },
      {
        name: "settings",
        title: t("secure.facility.admin.013"),
        icon: "cog",
        options: settingsOptions(),
        hidden: authStore?.user?.permissions?.tee_sheet_starter || !authStore?.user?.permissions?.settings_access,
      },
      ...(permissions?.reports_access ? [reportPath] : []),
      {
        name: "email-marketing",
        title: t("Marketing"),
        icon: "megaphone",
        options: marketingOptions(facilityStore?.facility),
        hidden: authStore?.user?.permissions?.tee_sheet_starter,
      },
      {
        name: "website-builder",
        title: t("Website Builder"),
        icon: "layer-group",
        options: websiteBuilderOptions(),
        hidden:
          authStore?.user?.permissions?.tee_sheet_starter || !facilityStore?.facility?.module_website_builder,
      },
      ...(facilityStore?.facility?.module_accommodations ? [accommodationPath] : []),
    ];

  const settingsPath = paths.find(path => path.name === "settings");

  useEffect(() => {
    const pathname = history.location.pathname;
    const foundPath = paths?.find(path =>
      path.options?.length
        ? path.options.some(option => isAdminNavOptionActive(pathname, option?.url))
        : pathname.split("/").includes(path.name),
    );
    const routeSegments = pathname.split("/");
    setCurrentRoute(foundPath?.name ?? routeSegments[routeSegments.length - 1]);
    setCurrentPath(foundPath);
  }, [history.location.pathname, i18n.language, facilityStore?.facility]);

  const handleMenuItemClick = (path: IPath) => {
    if (mobileLeftMenuVisible && windowSize.width <= MOBILE_WIDTH && (!path?.options || path.options.length === 0)) {
      setMobileLeftMenuVisible(false);
    }

    ReactDOM.unstable_batchedUpdates(() => {
      setCurrentRoute(path.name);
      setCurrentPath(path);
    });
  };

  const [displayReaders, setDisplayReaders] = useState<boolean>(false);
  //Handle undefined status
  const [readerStatus, setReaderStatus] = useState({
    status: "",
    color: "bg-black",
  });

  const handleReaderSheet = () => {
    if (mobileLeftMenuVisible && windowSize.width <= MOBILE_WIDTH) {
      setMobileLeftMenuVisible(false);
    }
    if (displayReaders) {
      setDisplayReaders(false);
    } else {
      setDisplayReaders(true);
    }
  };
  useEffect(() => {
    console.log("useEffect triggered!");
    console.log("terminalStore:", terminalStore);
    console.log("terminalStore.status:", terminalStore.status);
    console.log("Type of status:", typeof terminalStore.status);

    if (terminalStore.status !== undefined) {
      console.log("Status is NOT undefined, updating...");
      setReaderStatus(prevState => {
        console.log("Previous state:", prevState);
        const newState = { ...prevState, status: terminalStore.status };
        console.log("New state after status update:", newState);
        return newState;
      });

      if (terminalStore.status === "Connected") {
        console.log("Setting color to green (Connected)");
        setReaderStatus(prevState => ({ ...prevState, color: "bg-green-600" }));
      } else if (terminalStore.status === "Not connected") {
        console.log("Setting color to red (Not connected)");
        setReaderStatus(prevState => ({ ...prevState, color: "bg-red-600" }));
      } else if (terminalStore.status === "Selected") {
        console.log("Setting color to green (Selected)");
        setReaderStatus(prevState => ({ ...prevState, color: "bg-green-600" }));
      } else {
        console.log("Setting color to yellow (other status):", terminalStore.status);
        setReaderStatus(prevState => ({ ...prevState, color: "bg-yellow-500" }));
      }
    } else {
      console.log("Status IS undefined!");
    }

    console.log("Final readerStatus after updates:", readerStatus);
  }, [terminalStore.status]);

  // Changing Current Active User
  const [displayCurrentActiveUserSheet, setDisplayCurrentActiveUserSheet] = useState<boolean>(false);
  const [currentActiveUserCode, setCurrentActiveUserCode] = useState<string>("");

  const [switchUserAfterTransaction, setSwitchUserAfterTransaction] = useState<boolean>(false);

  const handleOpenCurrentActiveUserSheet = () => {
    if (mobileLeftMenuVisible && windowSize.width <= MOBILE_WIDTH) {
      setMobileLeftMenuVisible(false);
    }
    setDisplayCurrentActiveUserSheet(true);
    setCurrentActiveUserCode("");
  };

  const handleCloseCurrentActiveUserSheet = () => {
    setDisplayCurrentActiveUserSheet(false);
    setSwitchUserAfterTransaction(false);
    setCurrentActiveUserCode("");
  };

  const handleUpdateCurrentActiveUser = async () => {
    if (isPositiveInteger(currentActiveUserCode)) {
      const prevUserStarter = authStore?.user?.permissions?.tee_sheet_starter;
      const switchUserResponse = await SwitchUser({ quick_code: parseInt(currentActiveUserCode) }, true);

      if (switchUserResponse.status !== StatusCode.OK) {
        props.uiActions.showError(t("secure.facility.admin.014"));
        return;
      }

      facilityActions.loadAdminFacility({ client: true }, false);

      authActions.userLogin(switchUserResponse.data.user);
      localStorage.setItem("localeLanguage", switchUserResponse.data.user.primary_locale);
      localStorage.setItem("localeLanguageWithCountry", switchUserResponse.data.user.primary_locale_country);
      localStorage.setItem("switch_user_after_transaction", "false");
      props.uiActions.showSuccess(t("secure.facility.admin.015"));

      if (switchUserResponse?.data?.user?.permissions?.kiosk_view) {
        // Send to kiosk
        history.replace("/admin/kiosk");
      } else if (switchUserResponse?.data?.user?.permissions?.tee_sheet_starter) {
        // Send to starter tee sheet
        history.push("/admin/starter-teesheet");
      } else if (prevUserStarter) {
        // Send to regular tee sheet
        history.push("/admin/teesheet");
      }

      handleCloseCurrentActiveUserSheet();
    }
  };

  const handleCurrentActiveUserCodeEnter = (event: any) => {
    if (event.code === "Enter" || event.code === "NumpadEnter") {
      void handleUpdateCurrentActiveUser();
    }
  };

  const handleCurrentActiveUserCodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentActiveUserCode(event.target.value);
  };

  useEffect(() => {
    const defaultRegisterGroup = JSON.parse(localStorage.getItem("register_group"));
    if (defaultRegisterGroup) {
      void loadReaders();
    }
  }, [localStorage.getItem("register_group")]);

  //*************
  // REGISTERS
  const [displayRegisters, setDisplayRegisters] = useState<boolean>(false);
  const [registerState, setRegisterState] = useState({
    registers: [],
    selectedRegister: null,
    defaultFolderId: null,
  });

  useEffect(() => {
    if (facilityStore?.openRegistersSheet) {
      setDisplayRegisters(true);
      void dispatch(setRegisterSheet(false));
    }
  }, [facilityStore?.openRegistersSheet]);

  useEffect(() => {
    if (facilityStore?.facility) {
      setRegisterState(prevState => {
        let usableRegister = false;
        const register = JSON.parse(localStorage.getItem("register"));
        if (register) {
          //Check if current selected facility matches the logged in facility
          usableRegister = register?.facility_id === facilityStore?.facility?.id;
          if (!usableRegister) {
            //Register facility does not match logged in facility, reset register in local storage
            localStorage.removeItem("register");
            localStorage.removeItem("register_group");
          }
        }
        return {
          ...prevState,
          selectedRegister: usableRegister ? register : null,
        };
      });

      if (facilityStore?.facility?.permissions?.enable_service_fees) {
        void facilityActions.loadServiceFees({ facility_id: facilityStore?.facility?.id }, false);
      }
    }
  }, [facilityStore?.facility]);

  useEffect(() => {
    if (facilityStore.registers.length > 0 && registerState.selectedRegister) {
      const updatedRegister = facilityStore.registers.find(r => r.id === registerState.selectedRegister.id);
      if (updatedRegister && updatedRegister.active_shift !== registerState.selectedRegister.active_shift) {
        setRegisterState(prev => ({
          ...prev,
          selectedRegister: updatedRegister,
        }));
        localStorage.setItem("register", JSON.stringify(updatedRegister));
      }
    }
  }, [facilityStore.registers, registerState.selectedRegister]);

  const handleRegisterModalVisibility = () => {
    if (mobileLeftMenuVisible && windowSize.width <= MOBILE_WIDTH) {
      setMobileLeftMenuVisible(false);
    }
    if (displayRegisters) {
      setDisplayRegisters(false);
    } else {
      // void loadRegisters();
      setDisplayRegisters(true);
    }
  };

  const handleRegisterChange = (register?: IRegister) => {
    // Close register modal
    handleRegisterModalVisibility();

    // handle the new register
    if (register) {
      setRegisterState(prev => ({
        ...prev,
        selectedRegister: register,
        defaultFolderId: register.default_folder_id,
      }));

      localStorage.setItem("register", JSON.stringify(register));
      localStorage.setItem("default_folder_id", JSON.stringify(register.default_folder_id));
      localStorage.setItem("register_group", JSON.stringify(register.register_group));
    }
  };

  // PRINTERS
  const [displayPrinters, setDisplayPrinters] = useState<boolean>(false);
  const [printerState, setPrinterState] = useState({
    printers: [],
    selectedPrinter: null,
  });

  async function loadDefaulPrinter(facilityId: number) {
    if (!facilityId) {
      return null;
    }

    const source = axios.CancelToken.source();

    if (!localStorage.getItem(`printer_${facilityId}`)) {
      const res = await GetPrinterAll({}, source.token ? false : true, source.token);

      if (res.status === StatusCode.OK && res.data && res.data.length > 0) {
        const printer = res.data[0] as IPrinter;

        localStorage.setItem(`printer_${facilityId}`, JSON.stringify(printer));

        return printer;
      }

      return null;
    } else {
      // Check if printer in local storage still exists in printers table
      // If not, remove printer from local storage
      const res = await GetPrinterAll({}, source.token ? false : true, source.token);

      if (res.status === StatusCode.OK && res.data) {
        if (res.data.length === 0) {
          localStorage.removeItem(`printer_${facilityId}`);
          return null;
        }

        const selectedPrinterId = JSON.parse(localStorage.getItem(`printer_${facilityId}`))?.id;

        for (const printer of res.data) {
          if (printer.id === selectedPrinterId) {
            localStorage.setItem(`printer_${facilityId}`, JSON.stringify(printer));
            return printer;
          }
        }

        const printer = res.data[0] as IPrinter;

        localStorage.setItem(`printer_${facilityId}`, JSON.stringify(printer));

        return printer;
      }
    }

    return JSON.parse(localStorage.getItem(`printer_${facilityId}`)) as IPrinter;
  }

  useEffect(() => {
    const callback = async (facilityId: number) => {
      const selectedPrinter = await loadDefaulPrinter(facilityId);
      setPrinterState(prevState => ({
        ...prevState,
        selectedPrinter,
      }));
    };

    if (facilityStore.facility?.id) {
      void callback(facilityStore.facility?.id);
    }
  }, [facilityStore.facility?.id]);

  const handlePrinterModalVisibility = () => {
    if (mobileLeftMenuVisible && windowSize.width <= MOBILE_WIDTH) {
      setMobileLeftMenuVisible(false);
    }

    if (displayPrinters) {
      setDisplayPrinters(false);
    } else {
      setDisplayPrinters(true);
    }
  };

  const handlePrinterChange = (printer?: IPrinter) => {
    // Close printer modal
    handlePrinterModalVisibility();

    // handle the new printer
    if (printer) {
      setPrinterState(prev => ({
        ...prev,
        selectedPrinter: printer,
      }));

      if (facilityStore.facility?.id) {
        localStorage.setItem(`printer_${facilityStore.facility?.id}`, JSON.stringify(printer));
      }
    }
  };

  const loadReaders = async () => {
    const register_group = JSON.parse(localStorage.getItem("register_group"));
    if (register_group == null) {
      uiActions.showError(t("secure.facility.admin.016"));
      return;
    }

    uiActions.enqueue();
    try {
      await setupStripe(register_group?.id as number);
      //await discoverReaders(StripeTerminalSimulation, register_group?.stripe_location_id as string);
      const readers = await GetCardReaders(null, true);
      store.dispatch({
        type: "terminal.update",
        payload: {
          status: "Readers found",
          readers: readers.data,
        },
      });
    } catch (e) {
      console.error(e);
      uiActions.showError(t("secure.facility.admin.017"));
      uiActions.dequeue();
      return;
    }
    uiActions.dequeue();
  };

  const routeName = history.location.pathname;

  return (
    <>
      <FacilityTabTitle />
      {/** Connect to readers modal */}
      <Sheet
        size="medium"
        closable
        title={t("secure.facility.admin.024")}
        open={displayReaders}
        cancelText={t("secure.facility.admin.025")}
        onCancel={handleReaderSheet}
        okText={t("secure.facility.admin.026")}
        onOk={loadReaders}
      >
        {terminalStore.readers?.length > 0 ? (
          <div className="ui-checkbox-group">
            {terminalStore.readers
              .filter((reader: reader) =>
                [
                  "bbpos_wisepos_e",
                  "bbpos_wisepad_3",
                  "stripe_s700",
                  "stripe_s710",
                  "stripe_t600",
                  "simulated_wisepos_e",
                  "simulated_stripe_s700",
                  "simulated_stripe_s710",
                ].includes(reader.device_type),
              )
              .sort((a, b) => a.label?.localeCompare(b?.label))
              .map((reader: reader) => (
                <div
                  key={reader.serial_number}
                  onClick={() =>
                    connectReader(
                      reader,
                      true,
                      () => uiActions.showSuccess(t("secure.facility.admin.030")),
                      message => uiActions.showError(message),
                    )
                  }
                  className={classNames("ui-checkbox-group-item", {
                    "ui-checkbox-group-item_selected": reader.serial_number === terminalStore.reader?.serial_number,
                    "ui-checkbox-group-item_disabled": reader.status === "offline",
                  })}
                >
                  <div className="ui-checkbox-group-item-content">
                    <div className="ui-checkbox-group-item-lead">
                      <Icon size="small" icon={faCashRegister} />
                    </div>
                    <div className="ui-checkbox-group-item-text">
                      <p className="text-sm text-medium text-gray-700">{reader.label}</p>
                      <p className="text-sm text-medium text-gray-700">{reader.device_type?.replace(/_/g, " ")}</p>
                      <p className="text-sm text-medium text-gray-700">{reader.serial_number}</p>
                    </div>
                  </div>
                  <Checkbox
                    size="medium"
                    value={reader.serial_number}
                    checked={reader.serial_number === terminalStore.reader?.serial_number}
                    onChange={() =>
                      connectReader(
                        reader,
                        true,
                        () => uiActions.showSuccess(t("secure.facility.admin.030")),
                        message => uiActions.showError(message),
                      )
                    }
                  />
                  {/*<ButtonNew className="mt-2" onClick={() => disconnectReader()}>
                          {props.facilityStore.facility.terminal_integration === "server"
                            ? t("secure.facility.admin.035")
                            : t("secure.facility.admin.036")}
                        </ButtonNew> */}
                </div>
              ))}
          </div>
        ) : (
          <div className="flex justify-center align-center">
            <span className="text-xl text-bold self-center">{t("secure.facility.admin.032")}</span>
          </div>
        )}
      </Sheet>

      {routeName === "/admin/kds" ? (
        <Switch>
          <Route exact path="/admin/kds" component={kitchenDisplaySystem} />
        </Switch>
      ) : routeName === "/admin/kiosk" ? (
        <Switch>
          <Route exact path="/admin/kiosk" component={Kiosk} />
        </Switch>
      ) : routeName === "/admin/table-selection" ? (
        <Switch>
          <Route exact path="/admin/table-selection" component={TableSelection} />
        </Switch>
      ) : routeName === "/admin/table-service" ? (
        <Switch>
          <Route exact path="/admin/table-service" component={TableServiceContextProvider} />
        </Switch>
      ) : /^\/admin\/website-builder-editor(\/.*)?$/.test(routeName) ? (
        <Switch>
          <Route
            exact
            path="/admin/website-builder-editor/:pastWebsiteVersionId?"
            component={WebsiteBuilderEditorContainer}
          />
        </Switch>
      ) : /^\/admin\/email-marketing\/(campaigns|templates)\/[^/]+\/builder$/.test(routeName) ? (
        <Switch>
          <Route exact path="/admin/email-marketing/campaigns/:id/builder" component={EmailBuilder} />
          <Route exact path="/admin/email-marketing/templates/:id/builder" component={EmailBuilder} />
        </Switch>
      ) : routeName === "/admin/food-ordering/display" ? (
        <Switch>
          <Route exact path="/admin/food-ordering/display" component={FoodOrderChitMenu} />
        </Switch>
      ) : /^\/admin\/league\/.+\/scoring\/tv\/.+$/.test(routeName) ? (
        <Switch>
          <Route exact path={"/admin/league/:leagueId/scoring/tv/:scoresheetId"} component={LeagueTvLeaderboard} />
        </Switch>
      ) : /^\/admin\/league\/.+\/scoring\/tv-views\/.+\/view/.test(routeName) ? (
        <Switch>
          <Route exact path={baseLeagueUrl + "/scoring/tv-views/:viewId/view"} component={LeagueTvView} />
        </Switch>
      ) : authStore?.user?.permissions?.kiosk_view ? (
        <Switch>
          <Route exact path="/admin/kiosk" component={Kiosk} />
          <Redirect to="/admin/kiosk" />
        </Switch>
      ) : (
        <Layout>
          {mobileLeftMenuVisible && (!currentPath?.options || currentPath.options.length === 0) && (
            <div className="ui-layout_left-nav-mobile">
              <div className="ui-left-nav_container">
                <div className="ui-left-nav_content">
                  <div className="ui-left-nav-logo">
                    <img src={teeOnMenuLogo} alt={t("Tee-On Logo")} />
                  </div>
                  <div className="ui-left-nav-menu">
                    <Menu>
                      {paths.map((path, i) => {
                        if (!path.hidden && path.name !== "settings") {
                          return (
                            <Link key={i} to={`/admin/${path.name}`}>
                              <Menu.Item
                                selected={currentRoute === path.name ? true : false}
                                onClick={() => handleMenuItemClick(path)}
                                fullWidthIcon
                                icon={
                                  <div className="flex gap-1 items-center justify-between px-2 w-full">
                                    <div className="flex gap-1 items-center">
                                      <div className="w-6">
                                        {React.isValidElement(path.icon) ? (
                                          path.icon
                                        ) : (
                                          <FontAwesomeIcon icon={["far", path.icon as IconName]} />
                                        )}
                                      </div>
                                      <div>{path.title}</div>
                                    </div>
                                    <FontAwesomeIcon className="mr-1" icon={faChevronRight} />
                                  </div>
                                }
                              ></Menu.Item>
                            </Link>
                          );
                        }
                      })}
                    </Menu>
                    <Menu className="mb-4">
                      {/* Readers / Register section */}
                      <div className="px-4 py-3 border-t border-[#314365]">
                        <div
                          className="flex items-center gap-2 mb-2 cursor-pointer"
                          onClick={handleRegisterModalVisibility}
                        >
                          <div className={`rounded-full h-2 w-2 ${registerState.selectedRegister ? "bg-green-500" : "bg-gray-500"} flex-shrink-0`} />
                          <span className="text-sm text-white font-medium">
                            {registerState.selectedRegister ? registerState.selectedRegister.title : t("secure.facility.admin.018")}
                          </span>
                        </div>
                        <div
                          className="flex items-center gap-2 cursor-pointer"
                          onClick={handleReaderSheet}
                        >
                          <div className={`rounded-full h-2 w-2 ${readerStatus.color} flex-shrink-0`} />
                          <span className="text-sm text-white font-medium">
                            {terminalStore.reader ? terminalStore.reader.label : t("secure.facility.admin.020")}
                          </span>
                        </div>
                      </div>

                      {/* Settings */}
                      {settingsPath && !settingsPath.hidden && (
                        <div className="border-t border-[#314365]">
                          <Link to={`/admin/${settingsPath.name}`}>
                            <Menu.Item
                              selected={currentRoute === settingsPath.name}
                              onClick={() => handleMenuItemClick(settingsPath)}
                              fullWidthIcon
                              icon={
                                <div className="flex gap-1 items-center justify-between px-2 w-full">
                                  <div className="flex gap-1 items-center">
                                    <div className="w-6">
                                      <FontAwesomeIcon icon={["far", "cog"]} />
                                    </div>
                                    <div>{settingsPath.title}</div>
                                  </div>
                                  <FontAwesomeIcon className="mr-1" icon={faChevronRight} />
                                </div>
                              }
                            />
                          </Link>
                        </div>
                      )}

                      {/* Support */}
                      <div className="border-t border-[#314365]">
                        <SupportTab>
                          <Menu.Item
                            className="self-center cursor-pointer"
                            fullWidthIcon
                            icon={
                              <div className="flex gap-1 items-center justify-between px-2 w-full">
                                <div className="flex gap-1 items-center">
                                  <div className="w-6">
                                    <FontAwesomeIcon icon={faCircleInfo} />
                                  </div>
                                  <div>{t("secure.facility.admin.042")}</div>
                                </div>
                              </div>
                            }
                          ></Menu.Item>
                        </SupportTab>
                      </div>

                      {/* Profile */}
                      <div className="border-t border-[#314365]">
                        <UserProfileTab handleSwitchUser={handleOpenCurrentActiveUserSheet}>
                          <Menu.Item
                            onClick={() => { }}
                            className="self-center cursor-pointer"
                            fullWidthIcon
                            icon={
                              <div className="flex items-center justify-between px-2 w-full">
                                <div className="flex gap-3 items-center">
                                  <div className="admin-user-profile-image" style={{ margin: 0 }}>
                                    <p style={{ padding: 0 }}>
                                      {authStore?.user?.first_name?.charAt(0)}
                                      {authStore?.user?.last_name?.charAt(0)}
                                    </p>
                                  </div>
                                  <div className="flex flex-col text-left">
                                    <span className="text-sm font-semibold text-white">
                                      {authStore?.user?.first_name} {authStore?.user?.last_name}
                                    </span>
                                    <span className="text-xs text-gray-400">
                                      {authStore?.user?.email}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            }
                          />
                        </UserProfileTab>
                        <Menu.Item
                          className="self-center cursor-pointer mt-1 mb-4"
                          onClick={logoutUser}
                          fullWidthIcon
                          icon={
                            <div className="flex gap-3 items-center px-2 w-full">
                              <div className="w-8 flex justify-center">
                                <FontAwesomeIcon icon={["far", "arrow-right-from-bracket"]} style={{ color: "#8492A6", fontSize: "20px" }} />
                              </div>
                              <div className="text-sm font-semibold text-gray-300">{t("secure.facility.admin.043")}</div>
                            </div>
                          }
                        ></Menu.Item>
                      </div>
                    </Menu>
                  </div>
                </div>
              </div>
            </div>
          )}

          {mobileLeftMenuVisible && currentPath?.options?.length > 0 && (
            <div className="ui-layout_left-nav-icons-mobile">
              <div className="ui-left-nav_container">
                <div className="ui-left-nav_content">
                  <div className="ui-left-nav-logo">
                    <img src={teeOnMenuLogo} alt={t("Tee-On Logo")} />
                  </div>
                  <div className="ui-left-nav-menu">
                    <Menu>
                      {paths.map((path, i) => {
                        if (!path.hidden && path.name !== "settings") {
                          return (
                            <Link key={i} to={`/admin/${path.name}`}>
                              <Menu.Item
                                selected={currentRoute === path.name ? true : false}
                                onClick={() => handleMenuItemClick(path)}
                                icon={
                                  React.isValidElement(path.icon) ? (
                                    path.icon
                                  ) : (
                                    <FontAwesomeIcon icon={["far", path.icon as IconName]} />
                                  )
                                }
                              ></Menu.Item>
                            </Link>
                          );
                        }
                      })}
                    </Menu>
                    <Menu className="mb-4">
                      {settingsPath && !settingsPath.hidden && (
                        <Link to={`/admin/${settingsPath.name}`}>
                          <Menu.Item
                            selected={currentRoute === settingsPath.name}
                            onClick={() => handleMenuItemClick(settingsPath)}
                            icon={<FontAwesomeIcon icon={["far", "cog"]} />}
                          />
                        </Link>
                      )}
                      <SupportTab>
                        <Menu.Item
                          className="self-center cursor-pointer"
                          icon={<FontAwesomeIcon icon={faCircleInfo} />}
                        />
                      </SupportTab>
                      <UserProfileTab handleSwitchUser={handleOpenCurrentActiveUserSheet}>
                        <Menu.Item
                          onClick={() => { }}
                          className="self-center cursor-pointer"
                          icon={
                            <div className="admin-user-profile-image">
                              <p>
                                {authStore?.user?.first_name?.charAt(0)}
                                {authStore?.user?.last_name?.charAt(0)}
                              </p>
                            </div>
                          }
                        />
                      </UserProfileTab>
                      <Menu.Item
                        onClick={logoutUser}
                        className="self-center cursor-pointer"
                        icon={<FontAwesomeIcon style={{ transform: "scaleX(-1)" }} icon={["far", "sign-out"]} />}
                      />
                    </Menu>
                  </div>
                </div>
              </div>
            </div>
          )}

          {mobileLeftMenuVisible && (
            <>
              <div
                onClick={() => setMobileLeftMenuVisible(prev => !prev)}
                className="ui-layout_left-nav-mobile-backdrop"
              />
              <FontAwesomeIcon
                onClick={() => setMobileLeftMenuVisible(prev => !prev)}
                className="ui-layout_left-nav-mobile-backdrop-close-button"
                icon={faXmark}
              />
            </>
          )}

          {canViewSubMenu && (
            <div
              className={classNames("ui-layout_left-submenu-mobile", {
                "ui-layout_left-submenu-mobile-hide": mobileLeftMenuVisible && currentPath?.options ? false : true,
              })}
            >
              <LeftSubMenu
                title={currentPath?.title}
                options={currentPath?.options}
                onClickTitle={() => (currentPath?.OnClickTitle ? currentPath?.OnClickTitle() : undefined)}
                onClickOption={() => setMobileLeftMenuVisible(false)}
              />
            </div>
          )}

          <div className="ui-layout_left-nav-desktop">
            <div className="ui-left-nav_container">
              <div className="ui-left-nav_content">
                <div className="ui-left-nav-logo">
                  <img
                    src={teeOnMenuLogo}
                    alt={t("Tee-On Logo")}
                    onClick={handleLogoClick}
                    style={{ cursor: "pointer" }}
                  />
                </div>
                <div className="ui-left-nav-menu">
                  <Menu>
                    {paths.map((path, i) => {
                      if (!path.hidden && path.name !== "settings") {
                        return (
                          <Link key={i} to={`/admin/${path.name}`}>
                            <OverlayTrigger
                              placement="auto"
                              overlay={<Tooltip id="leftMenuToolTip">{path.title}</Tooltip>}
                            >
                              <Menu.Item
                                selected={currentRoute === path.name ? true : false}
                                onClick={() => handleMenuItemClick(path)}
                                icon={
                                  React.isValidElement(path.icon) ? (
                                    path.icon
                                  ) : (
                                    <FontAwesomeIcon icon={["far", path.icon as IconName]} />
                                  )
                                }
                              ></Menu.Item>
                            </OverlayTrigger>
                          </Link>
                        );
                      }
                    })}
                  </Menu>
                  <Menu className="mb-4">
                    {settingsPath && !settingsPath.hidden && (
                      <Link to={`/admin/${settingsPath.name}`}>
                        <OverlayTrigger
                          placement="auto"
                          overlay={<Tooltip id="leftMenuToolTip">{settingsPath.title}</Tooltip>}
                        >
                          <Menu.Item
                            selected={currentRoute === settingsPath.name}
                            onClick={() => handleMenuItemClick(settingsPath)}
                            icon={<FontAwesomeIcon icon={["far", "cog"]} />}
                          />
                        </OverlayTrigger>
                      </Link>
                    )}
                    <SupportTab>
                      <Menu.Item
                        className="self-center cursor-pointer"
                        icon={<FontAwesomeIcon icon={faCircleInfo} />}
                      />
                    </SupportTab>
                    <UserProfileTab handleSwitchUser={handleOpenCurrentActiveUserSheet}>
                      <Menu.Item
                        onClick={() => { }}
                        className="self-center cursor-pointer"
                        icon={
                          <div className="admin-user-profile-image">
                            <p>
                              {authStore?.user?.first_name?.charAt(0)}
                              {authStore?.user?.last_name?.charAt(0)}
                            </p>
                          </div>
                        }
                      />
                    </UserProfileTab>
                    <OverlayTrigger
                      placement="auto"
                      overlay={<Tooltip id="leftMenuToolTip">{`${t("secure.facility.admin.019")}`}</Tooltip>}
                    >
                      <Menu.Item
                        onClick={logoutUser}
                        className="self-center cursor-pointer"
                        icon={<FontAwesomeIcon style={{ transform: "scaleX(-1)" }} icon={["far", "sign-out"]} />}
                      />
                    </OverlayTrigger>
                  </Menu>
                </div>
              </div>
            </div>
          </div>

          {canViewSubMenu && (
            <div
              className={classNames("ui-layout_left-submenu-desktop", {
                "ui-layout_left-submenu-desktop-hide": currentPath?.options ? false : true,
              })}
            >
              <LeftSubMenu
                title={currentPath?.title}
                options={currentPath?.options}
                onClickTitle={() => (currentPath?.OnClickTitle ? currentPath?.OnClickTitle() : undefined)}
              />
            </div>
          )}

          <div
            className={classNames("ui-main", { "ui-main-no-submenu": !canViewSubMenu })}
            style={mobileLeftMenuVisible && windowSize.width <= MOBILE_WIDTH ? { filter: "blur(5px)" } : {}}
          >
            <StatusBannerStack surface="facility_admin" />
            {authStore?.user?.support_session && (
              <div className="ui-support-session-bar">
                <span>
                  {t("Support")}: {authStore.user.full_name || authStore.user.email}{" "}
                  {t("viewing")} {facilityStore.facility?.long_name || t("facility")}
                </span>
                <button
                  type="button"
                  className="ui-support-session-bar__exit"
                  onClick={() => void handleExitSupportSession()}
                >
                  {t("Exit")}
                  <FontAwesomeIcon icon={faXmark} />
                </button>
              </div>
            )}
            <div className="ui-header">
              <div className="ui-header_container">
                <div className="ui-header-content_mobile">
                  <div className="header-content-image-container">
                    {facilityStore.facility?.logo_source && (
                      <img className="header-content-image" src={facilityStore.facility.logo_source} />
                    )}
                  </div>
                  <div className="header-content-image-container">
                    {facilityStore.facility?.logo_source && (
                      <img className="header-content-image" src="../../../public/images/Tee-On.png" />
                    )}
                  </div>
                  <div
                    className="header-menu-icon"
                    onClick={() => {
                      setMobileLeftMenuVisible(prev => !prev);
                    }}
                  >
                    <FontAwesomeIcon icon={["far", "bars"]} />
                  </div>
                </div>
                <div className="ui-header-content_desktop">
                  <div className="facility-details">
                    <img
                      className="header-content-image"
                      src={facilityStore.facility?.logo_source}
                      alt="Facility Logo"
                    />
                    <h2 className="header-title">{facilityStore.facility?.long_name}</h2>
                  </div>
                  <div className="admin-details">
                    {printerState.selectedPrinter ? (
                      <div className="admin-terminal" onClick={() => handlePrinterModalVisibility()}>
                        <div className="admin-current-active-printer flex items-center gap-2">
                          <div className="relative">
                            <div className="circle-background">
                              {" "}
                              <FontAwesomeIcon icon={faPrint} />
                            </div>
                            <div
                              className={`status-dot  ${printerState.selectedPrinter ? "bg-green-600" : "bg-gray-400"}`}
                            />
                          </div>

                          <span className="admin-terminal-value ml-2">
                            {printerState.selectedPrinter?.title ?? "Printer"}
                          </span>
                        </div>
                      </div>
                    ) : null}

                    <div className="separator-line"> </div>

                    <div className="admin-terminal" onClick={() => handleRegisterModalVisibility()}>
                      <div className="admin-register-status flex items-center gap-2">
                        <div className="relative">
                          <div className="circle-background">
                            {" "}
                            <FontAwesomeIcon icon={faCashRegister} />{" "}
                          </div>
                          <div
                            className={`status-dot ${registerState.selectedRegister
                              ? "bg-green-600"
                              : "bg-gray-400"
                              }`}
                          />
                        </div>
                        {/* <span>Register</span> */}
                        {registerState.selectedRegister ? (
                          <span className="admin-terminal-value ml-2">
                            {registerState.selectedRegister?.title ?? "Register"}
                          </span>
                        ) : (
                          <span className="admin-terminal-value">{t("secure.facility.admin.018")}</span>
                        )}
                      </div>
                    </div>

                    <div className="separator-line"> </div>
                    <div className="" onClick={() => handleReaderSheet()}>
                      <span className="admin-terminal-value mr-2 flex items-center gap-2">
                        <div className="relative">
                          <div className="circle-background">
                            <FontAwesomeIcon icon={faCreditCard} />
                          </div>
                          <div className={`status-dot ${readerStatus.color}`} />
                        </div>
                        <div className="admin-terminal">
                          <div className="admin-terminal-status">
                            <span className="admin-terminal-value">
                              {" "}
                              {terminalStore.reader ? terminalStore.reader.label : t("secure.facility.admin.020")}
                            </span>
                          </div>
                        </div>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={classNames("ui-main_container", {
                "ui-main_container-teesheet": isTeesheetShellRoute,
              })}
            >
              <div className={adminContentCls}>
                <Switch>
                  <Route exact path="/admin/customers" component={Customers} />
                  <Route exact path="/admin/customers-public" component={Customers} />
                  <Route exact path="/admin/customers-member" component={MembershipsSold} />
                  <Route exact path="/admin/customers-credit-books" component={CreditBooks} />
                  <Route exact path="/admin/customers/:customerId/profile" component={CustomerProvider} />
                  <Route exact path="/admin/customers/:customerId/reservations" component={CustomerProvider} />
                  <Route exact path="/admin/customers/:customerId/membership" component={CustomerProvider} />
                  <Route exact path="/admin/customers/:customerId/tickets" component={CustomerProvider} />
                  <Route exact path="/admin/customers/:customerId/house-accounts" component={CustomerProvider} />
                  <Route exact path="/admin/customers/:customerId/payment-methods" component={CustomerProvider} />
                  <Route exact path="/admin/customers/:customerId/credit" component={CustomerProvider} />
                  <Route exact path="/admin/customers/:customerId/notes" component={CustomerProvider} />
                  <Route exact path="/admin/customers/:customerId/item-sales" component={CustomerProvider} />
                  <Route exact path="/admin/customers/:customerId/loyalty-program" component={CustomerProvider} />
                  <Route exact path="/admin/customers/:customerId/playing-partners" component={CustomerProvider} />

                  {/* <Route exact path="/admin/customer/new" component={CustomerNew} /> */}
                  {/* <Route exact path="/admin/customers/:customerId/profile" component={Customer} />
                  <Route exact path="/admin/customers/:customerId/reservations" component={Customer} />
                  <Route exact path="/admin/customers/:customerId/membership" component={Customer} />
                  <Route exact path="/admin/customers/:customerId/houseAccounts" component={Customer} />
                  <Route exact path="/admin/customers/:customerId/billing" component={Customer} />
                  <Route exact path="/admin/customers/:customerId/payment-methods" component={Customer} />
                  <Route exact path="/admin/customers/:customerId/item-sales" component={Customer} /> */}

                  {/* Temporarily disable dashboard route */}
                  <Route exact path="/admin/dashboard" component={DashboardNewContextProvider} />

                  <Route exact path="/admin/register" component={RegisterContextProvider} />
                  {permissions?.reports_access && [
                    <Route exact path="/admin/report" key="/admin/report" component={Reports} />,
                    reportRoutes?.map((route, index) => {
                      return <Route key={index} path={route.path} component={route.component} exact />;
                    }),
                    <Route
                      exact
                      path="/admin/report/scheduled"
                      key="/admin/report/scheduled"
                      component={ScheduledReports}
                    />,
                    <Route exact path="/admin/report/:id" key="/admin/report/:id" component={Report} />,
                  ]}

                  {/* Settings routes */}
                  <Route path="/admin/settings" component={Settings} exact />
                  {settingsRoutes?.map((route, index) => {
                    return <Route key={index} path={route.path} component={route.component} exact />;
                  })}

                  {/* Order routes */}
                  {orderRoutes?.map((route, index) => {
                    return <Route key={index} path={route.path} component={route.component} exact />;
                  })}

                  {/* Product routes */}
                  {productRoutes?.map((route, index) => {
                    return <Route key={index} path={route.path} component={route.component} exact />;
                  })}

                  {/* Customer routes */}
                  {/* {customerRoutes?.map((route, index) => {
                    return <Route key={index} path={route.path} component={route.component} exact />;
                  })} */}

                  {/* Website Builder routes */}
                  {websiteBuilderRoutes?.map((route, index) => {
                    return <Route key={index} path={route.path} component={route.component} exact />;
                  })}

                  <Route exact path="/admin/teesheet" component={NewTeeSheet} />

                  {/* <--------- Starter Tee Sheet --------- > */}
                  <Route exact path="/admin/starter-teesheet" component={StarterTeeSheet} />
                  <Route exact path="/admin/starter-teesheet-cart-inventory" component={CartInventory} />
                  <Route exact path="/admin/starter-teesheet-cart-inventory/new" component={NewCartInventory} />
                  {/* <--------- Starter Tee Sheet --------- > */}

                  <Route exact path="/admin/teesheet/edit" component={TeeSheetEdit} />
                  <Route exact path="/admin/teesheet/details/:teetimeId" component={TeeSheetDetailsContextProvider} />
                  <Route exact path="/admin/teesheet/details/:teetimeId" component={TeeSheetDetailsContextProvider} />

                  <Route exact path="/admin/reservation" component={Reservation} />
                  <Route exact path="/admin/reservation/edit/:moduleId" component={EditSegments} />

                  <Route exact path="/admin/events" component={Leagues} />
                  <Route exact path="/admin/events/new" component={LeagueNew} />
                  <Route exact path={baseLeagueUrl + "/home"} component={League} />
                  <Route exact path={baseLeagueUrl + "/players"} component={LeaguePlayers} />
                  <Route exact path={baseLeagueUrl + "/announcements"} component={LeagueAnnouncements} />
                  <Route exact path={baseLeagueUrl + "/prizeAccounts"} component={LeaguePrizeAccounts} />
                  <Route exact path={baseLeagueUrl + "/prizeAccounts/edit/:id"} component={PrizeAccount} />
                  <Route exact path={baseLeagueUrl + "/prizeAccounts/view/:id"} component={PrizeAccountView} />
                  <Route exact path={baseLeagueUrl + "/prizeAccounts/new"} component={PrizeAccountNew} />
                  <Route exact path={baseLeagueUrl + "/rounds"} component={LeagueRounds} />

                  <Route exact path={baseLeagueUrl + "/divisions"} component={LeagueDivisions} />
                  <Route exact path={baseLeagueUrl + "/divisions/new"} component={LeagueDivisionsNew} />
                  <Route
                    exact
                    path={baseLeagueUrl + "/divisions/:divisionId/manage_players"}
                    component={LeagueDivisionsManagePlayers}
                  />

                  <Route exact path={baseLeagueUrl + "/divisions/:divisionId/edit"} component={LeagueDivisionEdit} />

                  <Route exact path={baseLeagueUrl + "/divisions/:divisionId/teams"} component={LeagueTeams} />
                  <Route exact path={baseLeagueUrl + "/divisions/:divisionId/teams/new"} component={LeagueTeamNew} />
                  <Route
                    exact
                    path={baseLeagueUrl + "/divisions/:divisionId/teams/manage_players"}
                    component={LeaguePlayerManage}
                  />

                  <Route
                    exact
                    path={baseLeagueUrl + "/divisions/:divisionId/teams/:teamId/edit"}
                    component={LeagueTeamsEdit}
                  />
                  <Route exact path={baseLeagueUrl + "/divisions/:divisionId/flights"} component={LeagueFlights} />
                  <Route
                    exact
                    path={baseLeagueUrl + "/divisions/:divisionId/flights/new"}
                    component={LeagueFlightsNew}
                  />
                  <Route
                    exact
                    path={baseLeagueUrl + "/divisions/:divisionId/flights/manage_players"}
                    component={LeagueFlightPlayerManage}
                  />
                  <Route
                    exact
                    path={baseLeagueUrl + "/divisions/:divisionId/flights/:flightId/edit"}
                    component={LeagueFlightsEdit}
                  />
                  <Route exact path={baseLeagueUrl + "/rounds/scoresheet/new"} component={LeagueScoresheetNew} />
                  <Route
                    exact
                    path={baseLeagueUrl + "/rounds/scoresheet/:scoresheetId/scores"}
                    component={LeagueScoresheet}
                  />
                  <Route
                    exact
                    path={baseLeagueUrl + "/rounds/scoresheet/:scoresheetId/scoring-formats/new"}
                    component={LeagueScoringFormatNew}
                  />
                  <Route
                    exact
                    path={baseLeagueUrl + "/rounds/scoresheet/:scoresheetId/scoring-formats/:formatId"}
                    component={LeagueScoringFormatEdit}
                  />
                  <Route
                    exact
                    path={baseLeagueUrl + "/rounds/scoresheet/:scoresheetId/leaderboard"}
                    component={LeagueLeaderboard}
                  />

                  <Route
                    exact
                    path={baseLeagueUrl + "/rounds/scoresheet/:scoresheetId/overview"}
                    component={LeagueRoundOverview}
                  />
                  <Route
                    exact
                    path={baseLeagueUrl + "/rounds/scoresheet/:scoresheetId/edit"}
                    component={LeagueScoresheetEdit}
                  />
                  <Route
                    exact
                    path={baseLeagueUrl + "/scoring/scoresheet/:scoresheetId/skins"}
                    component={LeagueSkins}
                  />
                  <Route
                    exact
                    path={baseLeagueUrl + "/scoring/scoresheet/:scoresheetId/skins/:skinsheetId"}
                    component={LeagueSkin}
                  />
                  <Route
                    exact
                    path={baseLeagueUrl + "/scoring/season-leaderboard"}
                    component={LeagueSeasonLeaderboard}
                  />
                  <Route exact path={baseLeagueUrl + "/scoring/leaderboards"} component={Leaderboards} />
                  <Route
                    exact
                    path={baseLeagueUrl + "/scoring/leaderboards/:leaderboardId"}
                    component={LeaderboardTotals}
                  />
                  <Route exact path={baseLeagueUrl + "/scoring/ringer-board"} component={LeagueRingerBoard} />
                  <Route exact path={baseLeagueUrl + "/scoring/statistics"} component={LeagueStatistics} />
                  <Route exact path={baseLeagueUrl + "/league-settings/organizers"} component={LeagueOrganizers} />
                  <Route exact path={baseLeagueUrl + "/league-settings/teetimes"} component={LeagueTeeTimes} />
                  <Route
                    exact
                    path={baseLeagueUrl + "/league-settings/registration"}
                    component={LeagueRegistrationLanding}
                  />
                  <Route exact path={baseLeagueUrl + "/scoring/tv-views"} component={LeagueTvViews} />
                  <Route exact path={baseLeagueUrl + "/scoring/tv-views/new"} component={LeagueTvViewNew} />
                  <Route exact path={baseLeagueUrl + "/scoring/tv-views/:viewId/edit"} component={LeagueTvViewEdit} />
                  <Route exact path={baseLeagueUrl + "/league-settings/general"} component={SingleLeagueSettings} />
                  <Route
                    exact
                    path={baseLeagueUrl + "/league-settings/format-templates"}
                    component={LeagueFormatTemplates}
                  />
                  <Route
                    exact
                    path={baseLeagueUrl + "/league-settings/format-templates/new"}
                    component={LeagueFormatTemplateNew}
                  />
                  <Route
                    exact
                    path={baseLeagueUrl + "/league-settings/format-templates/:templateId"}
                    component={LeagueFormatTemplate}
                  />

                  <Route exact path="/admin/events-tournament" component={Tournaments} />
                  <Route exact path="/admin/events-tournament/new" component={TournamentNew} />
                  <Route exact path={baseTournamentUrl + "/home"} component={Tournament} />
                  <Route exact path={baseTournamentUrl + "/players"} component={TournamentPlayers} />
                  <Route exact path={baseTournamentUrl + "/teams"} component={TournamentTeams} />
                  <Route exact path={baseTournamentUrl + "/teams/new"} component={TournamentTeamNew} />
                  <Route exact path={baseTournamentUrl + "/teams/:teamId/edit"} component={TournamentTeam} />
                  <Route exact path={baseTournamentUrl + "/flights"} component={TournamentFlights} />
                  <Route exact path={baseTournamentUrl + "/flights/new"} component={TournamentFlightNew} />
                  <Route exact path={baseTournamentUrl + "/flights/:flightId/edit"} component={TournamentFlightEdit} />
                  <Route exact path={baseTournamentUrl + "/scoring"} component={TournamentScores} />

                  <Route exact path={baseTournamentUrl + "/prizeAccounts"} component={TournamentPrizeAccounts} />
                  <Route exact path={baseTournamentUrl + "/prizeAccounts/edit/:id"} component={PrizeAccount} />
                  <Route exact path={baseTournamentUrl + "/prizeAccounts/view/:id"} component={PrizeAccountView} />
                  <Route exact path={baseTournamentUrl + "/prizeAccounts/new"} component={PrizeAccountNew} />
                  <Route
                    exact
                    path={baseTournamentUrl + "/scoring/scoresheet/new"}
                    component={TournamentScoresheetNew}
                  />
                  <Route
                    exact
                    path={baseTournamentUrl + "/scoring/scoresheet/:scoresheetId"}
                    component={TournamentScoresheet}
                  />
                  <Route
                    exact
                    path={baseTournamentUrl + "/scoring/scoresheet/:scoresheetId/edit"}
                    component={TournamentScoresheetEdit}
                  />

                  <Route
                    exact
                    path={baseTournamentUrl + "/scoring/results/:scoresheetId"}
                    component={TournamentLeaderboard}
                  />

                  <Route
                    exact
                    path={baseTournamentUrl + "/tournament-settings/general"}
                    component={TournamentSettings}
                  />
                  <Route
                    exact
                    path={baseTournamentUrl + "/tournament-settings/registration"}
                    component={TournamentRegistrationLanding}
                  />
                  <Route
                    exact
                    path={baseTournamentUrl + "/tournament-settings/scoring"}
                    component={TournamentScoreSettings}
                  />
                  {/* <Route
                    exact
                    path={baseTournamentUrl + "/tournament-settings/registration"}
                    component={TournamentRegistration}
                  /> */}
                  {/* <Route
                    exact
                    path={baseTournamentUrl + "/tournament-settings/registration/registration-fees-new"}
                    component={TournamentRegistrationFeesNew}
                  /> */}
                  <Route
                    exact
                    path={baseTournamentUrl + "/tournament-settings/organizers"}
                    component={TournamentOrganizers}
                  />

                  <Route exact path="/admin/events-hospitality" component={HospitalityEvents} />
                  <Route exact path="/admin/events-hospitality/new" component={HospitalityEventNew} />
                  <Route exact path="/admin/event/:eventId/home" component={HospitalityEvent} />

                  {/* Events calendar */}
                  <Route exact path="/admin/events-calendar" component={EventsCalendarPage} />

                  {/* Marketing */}
                  <Route exact path="/admin/marketing" component={CustomerSegments} />
                  <Route exact path="/admin/marketing/customer-segments/new" component={NewCustomerSegment} />
                  <Route
                    exact
                    path="/admin/marketing/customer-segments/view/:segmentId"
                    component={ViewCustomerSegment}
                  />
                  <Route
                    exact
                    path="/admin/marketing/customer-segments/edit/:segmentId"
                    component={EditCustomerSegment}
                  />

                  <Route
                    exact
                    path={[
                      "/admin/email-marketing",
                      "/admin/email-marketing/templates",
                      "/admin/email-marketing/smart-lists",
                      "/admin/email-marketing/settings",
                    ]}
                    component={EmailMarketing}
                  />
                  <Route exact path="/admin/email-marketing/campaigns/smart-list/new" component={Audience} />
                  <Route exact path="/admin/email-marketing/campaigns/smart-list/:id" component={Audience} />
                  <Route
                    exact
                    path="/admin/email-marketing/campaigns/:id/select-template"
                    render={({ match }) => (
                      <Redirect to={`/admin/email-marketing/campaigns/${match.params.id}/new?step=3`} />
                    )}
                  />
                  <Route exact path="/admin/email-marketing/campaigns/:id/new" component={CreateEmailCampaign} />
                  <Route exact path="/admin/email-marketing/campaigns/:id/schedule" component={ScheduleEmailCampaign} />
                  <Route exact path="/admin/email-marketing/campaigns/:id" component={EmailCampaign} />
                  <Route
                    exact
                    path="/admin/email-marketing/campaigns/:id/top-links"
                    component={EmailCampaignTopLinkPreview}
                  />
                  <Route exact path="/admin/email-marketing/campaigns/:id/recipients/:metric" component={Recipients} />

                  {/* Newsletter */}
                  <Route exact path="/admin/newsletter" component={NewsletterPosts} />
                  <Route exact path="/admin/newsletter/new" component={NewsletterPostNew} />
                  <Route exact path="/admin/newsletter/:id" component={NewsletterPostEdit} />

                  {/* Accommodation Configuration */}
                  <Route exact path="/admin/accommodation/configuration/:tab?" component={AccommodationConfiguration} />

                  {/* Accommodation Calendar */}
                  <Route exact path="/admin/accommodation/calendar" component={AccommodationCalendar} />

                  {/* Accommodation Reservations */}
                  <Route exact path="/admin/accommodation" component={AccommodationReservations} />
                  <Route exact path="/admin/accommodation/reservations" component={AccommodationReservations} />
                  <Route
                    exact
                    path="/admin/accommodation/reservations/:reservationId"
                    component={EditAccommodationReservation}
                  />

                  {/* Accommodation Buildings */}
                  <Route exact path="/admin/accommodation/buildings/new" component={AccommodationBuildingNew} />
                  <Route
                    exact
                    path="/admin/accommodation/buildings/:buildingId"
                    component={AccommodationBuildingEdit}
                  />

                  {/* Accommodation Unit Types */}
                  <Route exact path="/admin/accommodation/unit-types/new" component={AccommodationUnitTypeNew} />
                  <Route exact path="/admin/accommodation/unit-types/:typeId" component={AccommodationUnitTypeEdit} />

                  {/* Accommodation Units */}
                  <Route exact path="/admin/accommodation/units/new" component={NewAccommodationUnit} />
                  <Route exact path="/admin/accommodation/units/:unitId" component={EditAccommodationUnit} />

                  {/* Accommodation Rates */}
                  <Route exact path="/admin/accommodation/rates/:tab?" component={AccommodationRatePlans} />
                  <Route
                    exact
                    path="/admin/accommodation/rates/details/:ratePlanId"
                    component={AccommodationEditRatePlan}
                  />

                  {/* <Route exact path="/admin/tournament/:tournamentId/settings" component={TournamentSettings} />
                      <Route
                        exact
                        path="/admin/tournament/:tournamentId/settings/general"
                        component={TournamentSettingsGeneral}
                      /> */}

                  {/* Temporary dashboard route */}
                  <Route exact path="/admin/dashboard-beta" component={Dashboard} />

                  <Redirect to="/admin/dashboard" />
                </Switch>
              </div>
            </div>
          </div>

          {/** Current Active User Modal */}
          <SwitchUserModal
            open={displayCurrentActiveUserSheet}
            onCancel={handleCloseCurrentActiveUserSheet}
            onOk={handleUpdateCurrentActiveUser}
            okDisabled={!isPositiveInteger(currentActiveUserCode)}
            userCode={currentActiveUserCode}
            onChange={handleCurrentActiveUserCodeChange}
            onKeyDown={handleCurrentActiveUserCodeEnter}
            autoFocus
          />

          {/* Display switch user modal with logout button */}
          <div className="ui-switch-user-modal">
            <SwitchUserModal
              open={switchUserAfterTransaction}
              onCancel={logoutUser}
              cancelText={t("secure.facility.admin.041")}
              onOk={handleUpdateCurrentActiveUser}
              okDisabled={!isPositiveInteger(currentActiveUserCode)}
              userCode={currentActiveUserCode}
              onChange={handleCurrentActiveUserCodeChange}
              onKeyDown={handleCurrentActiveUserCodeEnter}
              autoFocus
              backDropCancel={false}
            />
          </div>

          {/** Connect to Register modal */}
          <RegistersModal open={displayRegisters} onClose={register => handleRegisterChange(register)} />
          <PrintersModal open={displayPrinters} onClose={printer => handlePrinterChange(printer)} />
        </Layout>
      )}
    </>
  );
};

export default FacilityAdmin;
